/**
 * AI:
 * Status: "in progress"
 * Type: Component
 * SubType: CreateEditPage
 * Reason: CRUD component for creating and editing SmSigningProcess entities using metadata-driven forms via mvs-crud-object.
 */
import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {Observable} from 'rxjs';
import {Router} from '@angular/router';
import {
    ObjectChangeInformation,
    ObjectChangeInformationActionEnum
} from '../../../../../core/shared/logic/object-change-information';

@Component({
    selector: 'mvs-sm-signing-process-crud',
    templateUrl: './sm-signing-process-crud.component.html',
    styleUrls: ['./sm-signing-process-crud.component.scss'],
    standalone: false
})
export class SmSigningProcessCrudComponent implements OnInit, OnChanges {

    @Input() objectId: number;
    @Output() onChangedObject = new EventEmitter<ObjectChangeInformation>();

    objectType: string = 'sm.SmSigningProcess';
    formDirty: boolean = false;

    constructor(private router: Router) {
    }

    ngOnInit(): void {
        this.initComponent();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // React to input changes
    }

    initComponent(): void {
        // Component initialization
    }

    /**
     * Navigation guard. Returns true if the form is clean or the user confirms leaving.
     */
    canDeactivate(): Observable<boolean> | boolean {
        if (this.formDirty) {
            return confirm('You have unsaved changes. Leave anyway?');
        }
        return true;
    }

    /**
     * Handle create/update/delete events from the CRUD object component.
     */
    handleChanged(event: ObjectChangeInformation): void {
        this.onChangedObject.emit(event);

        switch (event.action) {
            case ObjectChangeInformationActionEnum.created:
                if (event.after?.id) {
                    this.router.navigate(['/sm/processes', event.after.id]);
                }
                break;
            case ObjectChangeInformationActionEnum.updated:
                break;
            case ObjectChangeInformationActionEnum.deleted:
                this.router.navigate(['/sm/processes']);
                break;
        }
    }

    /**
     * Handle form dirty state changes from the CRUD object component.
     */
    onFormDirty(isDirty: boolean): void {
        this.formDirty = isDirty;
    }
}
